<template>
  <section class="is-error-section " id="auth-section">
    <auth-top-navbar />
    <br />
    <div class="is-full-w helvetica" id="barra-rosa">
      <h4 class="title is-3">{{ $t('ZONA PRIVADA') }}</h4>
    </div>
    <div class="section no-padding-mobile">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6">
            <b-message v-if="guardingOnboardRoute">
              {{ $t('texto requerir cuenta') }}
            </b-message>
            <div
              title="Login"
              icon="lock"
              :has-card-header-background="true"
              :has-button-slot="true"
            >
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </div>
    <auth-bottom-navbar v-if="guardingOnboardRoute" />
  </section>
</template>

<script>
import AuthTopNavbar from '@/components/on-board/AuthTopNavbar'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'Auth',
  components: { AuthTopNavbar },
  methods: {
    ...mapActions('user', ['changeLocale']),
    updateLocale(val) {
      this.changeLocale(val)
      this.$i18n.locale = val
    }
  },
  computed: {
    ...mapState('user', ['locale']),
    ...mapGetters('user', ['locale']),
    guardingOnboardRoute() {
      if (!this.$store.getters.nextRoute) {
        return false
      }
      return this.$store.getters.nextRoute.name.includes('onBoard')
    }
  },
  mounted() {
    this.$store.commit('layout/FULL_PAGE', true)
  },
  beforeDestroy() {
    this.$store.commit('layout/FULL_PAGE', false)
  }
}
</script>

<style lang="scss" scoped>
card-component {
  background: white;
  display: block;
  padding: 40px;
  border: solid var(--rosa-dark-eco);
  border-radius: 20px;
  box-shadow: 0 5px 20px -10px;
}

#auth-section {
  min-height: 100%;
  background: #bbb;
  background-blend-mode: screen;
  background-image: url('~@/assets/skyline.jpg');
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}
.auth {
  margin: 0 auto;
  width: 460px;
}
.toggle {
  cursor: pointer;
  font-size: 18px;
}
.navbar-item img {
  margin-bottom: 7px;
  max-height: 100%;
}
.has-addons-centered .control {
  text-align: center;
}
#barra-rosa {
  background: var(--rosa-dark-eco);
  padding: 20px;
  text-align: center;

  .title {
    color: white;
  }
}
h1.card-title {
  font-size: xx-large;
}

.card {
  border-radius: 0;
}
</style>

<style>
a.customLink {
  color: #0a0a0a !important;
  font-size: 18px;
}

p.centered {
  text-align: center;
}

p.centered button {
  border-radius: 0;
}

.cornered select {
  border-radius: 0 !important;
}
</style>
